import MeetListView from './MeetListView';
export default MeetListView;



// WEBPACK FOOTER //
// ./src/scenes/Meets/components/MeetListView/index.js